const FETCH_UICONFIGDATA_SUCCESS = 'FETCH_UICONFIGDATA_SUCCESS'
const FETCH_MEDIATYPELIST_SUCCESS = 'FETCH_MEDIATYPELIST_SUCCESS'
const FETCH_STATIONCATEGORYLIST_SUCCESS = 'FETCH_STATIONCATEGORYLIST_SUCCESS'
const FETCH_CONTINUOUSSTATIONCATEGORYLIST_SUCCESS = 'FETCH_CONTINUOUSSTATIONCATEGORYLIST_SUCCESS'
const FETCH_TAGLIST_SUCCESS = 'FETCH_TAGLIST_SUCCESS'
const FETCH_DISCRETESTATIONSIDEMENUDATA_SUCCESS = 'FETCH_DISCRETESTATIONSIDEMENUDATA_SUCCESS'
const FETCH_CONTINUOUSSTATIONSIDEMENUDATA_SUCCESS = 'FETCH_CONTINUOUSSTATIONSIDEMENUDATA_SUCCESS'
const FETCH_DISCRETESTATIONLIST_SUCCESS = 'FETCH_DISCRETESTATIONLIST_SUCCESS'
const FETCH_CONTINUOUSSTATIONLIST_SUCCESS = 'FETCH_CONTINUOUSSTATIONLIST_SUCCESS'
const FETCH_MAPLAYERS_SUCCESS = 'FETCH_MAPLAYERS_SUCCESS'
const FETCH_LANDING_PAGE_STATIC_CONTENT_TEMPLATES = 'FETCH_LANDING_PAGE_STATIC_CONTENT_TEMPLATES'
const FETCH_LANDING_PAGE_STATIC_CONTENT_ITEMS = 'FETCH_LANDING_PAGE_STATIC_CONTENT_ITEMS'

function initialState() {
  return {
    uiConfigData: false,
    mediaTypeList: false,
    stationCategoryList: false,
    continuousStationCategoryList: false,
    tagList: false,
    discreteStationSideMenuData: false,
    continuousStationSideMenuData: false,
    discreteStationList: false,
    continuousStationList: false,
    mapLayers: false,
    landingPageStaticContentTemplates: false,
    landingPageStaticContentItems: false,
  }
}

export default {
  namespaced: true,
  state: initialState,
  actions: {
    fetchUiConfigDataSuccess({ commit }) {
      commit(FETCH_UICONFIGDATA_SUCCESS)
    },
    fetchMediaTypeListSuccess({ commit }) {
      commit(FETCH_MEDIATYPELIST_SUCCESS)
    },
    fetchStationCategoryListSuccess({ commit }) {
      commit(FETCH_STATIONCATEGORYLIST_SUCCESS)
    },
    fetchContinuousStationCategoryListSuccess({ commit }) {
      commit(FETCH_CONTINUOUSSTATIONCATEGORYLIST_SUCCESS)
    },
    fetchTagListSuccess({ commit }) {
      commit(FETCH_TAGLIST_SUCCESS)
    },
    fetchDiscreteStationSideMenuDataSuccess({ commit }) {
      commit(FETCH_DISCRETESTATIONSIDEMENUDATA_SUCCESS)
    },
    fetchContinuousStationSideMenuDataSuccess({ commit }) {
      commit(FETCH_CONTINUOUSSTATIONSIDEMENUDATA_SUCCESS)
    },
    fetchDiscreteStationListSuccess({ commit }) {
      commit(FETCH_DISCRETESTATIONLIST_SUCCESS)
    },
    fetchContinuousStationListSuccess({ commit }) {
      commit(FETCH_CONTINUOUSSTATIONLIST_SUCCESS)
    },
    fetchMapLayersSuccess({ commit }) {
      commit(FETCH_MAPLAYERS_SUCCESS)
    },
    fetchLandingPageStaticContentTemplatesSuccess({ commit }) {
      commit(FETCH_LANDING_PAGE_STATIC_CONTENT_TEMPLATES)
    },
    fetchLandingPageStaticContentItemsSuccess({ commit }) {
      commit(FETCH_LANDING_PAGE_STATIC_CONTENT_ITEMS)
    },
  },
  mutations: {
    RESET(state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    [FETCH_UICONFIGDATA_SUCCESS](state) {
      state.uiConfigData = true
    },
    [FETCH_MEDIATYPELIST_SUCCESS](state) {
      state.mediaTypeList = true
    },
    [FETCH_STATIONCATEGORYLIST_SUCCESS](state) {
      state.stationCategoryList = true
    },
    [FETCH_CONTINUOUSSTATIONCATEGORYLIST_SUCCESS](state) {
      state.continuousStationCategoryList = true
    },
    [FETCH_TAGLIST_SUCCESS](state) {
      state.tagList = true
    },
    [FETCH_DISCRETESTATIONSIDEMENUDATA_SUCCESS](state) {
      state.discreteStationSideMenuData = true
    },
    [FETCH_CONTINUOUSSTATIONSIDEMENUDATA_SUCCESS](state) {
      state.continuousStationSideMenuData = true
    },
    [FETCH_DISCRETESTATIONLIST_SUCCESS](state) {
      state.discreteStationList = true
    },
    [FETCH_CONTINUOUSSTATIONLIST_SUCCESS](state) {
      state.continuousStationList = true
    },
    [FETCH_MAPLAYERS_SUCCESS](state) {
      state.mapLayers = true
    },
    [FETCH_LANDING_PAGE_STATIC_CONTENT_TEMPLATES](state) {
      state.landingPageStaticContentTemplates = true
    },
    [FETCH_LANDING_PAGE_STATIC_CONTENT_ITEMS](state) {
      state.landingPageStaticContentItems = true
    },
  },
  getters: {
    getUiConfigDataState: s => s.uiConfigData,
    getMediaTypeListState: s => s.mediaTypeList,
    getStationCategoryListState: s => s.stationCategoryList,
    getContinuousStationCategoryListState: s => s.continuousStationCategoryList,
    getTagListState: s => s.tagList,
    getDiscreteStationSideMenuDataState: s => s.discreteStationSideMenuData,
    getContinuousStationSideMenuDataState: s => s.continuousStationSideMenuData,
    getDiscreteStationListState: s => s.discreteStationList,
    getContinuousStationListState: s => s.continuousStationList,
    getMapLayersState: s => s.mapLayers,
    getLandingPageStaticContentTemplatesState: s => s.landingPageStaticContentTemplates,
    getLandingPageStaticContentItems: s => s.landingPageStaticContentItems,
  },
}